import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const CustomInput = ({ label, name, type, value, onChange, placeholder, error, labelClassName }) => {
  const textareaRef = useRef(null);

  // Auto-resize textarea based on content
  useEffect(() => {
    if (type === 'textarea' && textareaRef.current) {
      const textarea = textareaRef.current;
      // Reset height to auto to calculate scrollHeight accurately
      textarea.style.height = 'auto';
      // Set height to scrollHeight to fit content
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [type, value]); // Re-run when value or type changes

  return (
    <div className="mb-1">
      <label className={`text-md font-semibold block mb-0 ${labelClassName || 'text-gray-900'}`}>
        {label}
      </label>
      {type === 'textarea' ? (
        <textarea
          ref={textareaRef}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows="10" // Set initial rows to 10
          className={`w-full px-3 bg-transparent border border-gray-700 rounded-lg text-gray-900 bg-white resize-y focus:outline-none focus:ring-2 focus:ring-blue-600 ${
            error ? 'border-red-500' : ''
          }`}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full p-3 bg-transparent border border-gray-700 rounded-lg text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-600 focus:bg-gray-100 ${
            error ? 'border-red-500' : ''
          }`}
        />
      )}
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

CustomInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  labelClassName: PropTypes.string,
};

CustomInput.defaultProps = {
  type: 'text',
  value: '',
  placeholder: '',
  error: null,
  labelClassName: '',
};

export default CustomInput;